/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import PostsUI from "./PostsUI";
import PostFormWrapper from "./PostFormWrapper";

/* helpers */
import * as globalActions from "../../../actions/globalActions";
import * as pagesActions from "../../../actions/pagesActions";
import * as postsActions from "../../../actions/postsActions";
import * as controlPanelActions from "../../../actions/controlPanelActions";

class PostsPage extends Component {
	constructor(props) {
		super(props);
		this.appKey = this.props.match.params.appKey;
	}

	componentDidMount() {
		const { loadPosts } = this.props.postsActions;
		loadPosts(this.appKey);
	}

	getAppId = key => {
		const { apps } = this.props;
		const app = apps.find(a => a.key === key);
		return app.id;
	};

	reloadPosts = () => {
		const { postsActions, history } = this.props;
		postsActions.loadPosts(this.appKey);
		history.push(`/apps/${this.appKey}/posts`);
	};

	loadPosts = expId => {
		this.props.pagesActions.loadPosts(expId);
	};

	logError = () => {
		//alert("Boo...");
		//console.log(">>>: ", JSON.stringify(error));
		//this.props.validationActions.updateFormErrors(error.response.data.Errors);
	};

	createItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const id = this.getAppId(this.appKey);
		const data = {
			...values,
			appId: id,
		};
		globalActions.createItem(data, "/posts", this.reloadPosts, this.logError, submitHandler);
	};

	updateItem = (values, submitHandler, itemId) => {
		//TODO: item to update has be different than what will be sent out
		const { globalActions } = this.props;
		globalActions.updateItem(values, `/posts/${itemId}`, this.reloadPosts, this.logError, submitHandler);
	};

	copyItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const id = this.getAppId(this.appKey);
		const data = {
			...values,
			appId: id,
		};
		globalActions.createItem(data, "/posts", this.reloadPosts, this.logError, submitHandler);
	};

	deleteItem = id => {
		let appKey = this.appKey;
		const { postsActions, globalActions } = this.props;
		const onSuccess = () => {
			postsActions.loadPosts(appKey);
		};
		globalActions.deleteItem(`/posts/${id}`, onSuccess, this.logError);
	};

	renderGrid = () => {
		const { posts } = this.props.posts;

		return (
			<div>
				{posts ? (
					<div className="posts-ui">
						<PostsUI delete={this.deleteItem} items={posts} appKey={this.appKey} />
					</div>
				) : (
					<div></div>
				)}
			</div>
		);
	};

	render() {
		const { posts } = this.props.posts;

		return (
			<Page title="Posts">
				{posts ? (
					<GridFormSwitcher
						objectKey="Posts"
						singleItemName="Post"
						pluralItemName="Posts"
						RenderCopy={PostFormWrapper}
						RenderEdit={PostFormWrapper}
						RenderNew={PostFormWrapper}
						items={posts}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
						loadPages={this.loadPages}
						posts={posts}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

PostsPage.propTypes = {
	match: PropTypes.any,
	posts: PropTypes.object,
	actions: PropTypes.any,
	globalActions: PropTypes.any,
	history: PropTypes.object,
	apps: PropTypes.array,
	pagesActions: PropTypes.object,
	postsActions: PropTypes.object,
	controlPanelActions: PropTypes.object,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
	posts: state.posts,
});

const mapDispatchToProps = dispatch => ({
	postsActions: bindActionCreators(postsActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
	pagesActions: bindActionCreators(pagesActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PostsPage);
